import { useAuth } from '@features/auth';
import type { File } from '../types';

export function useCanEditFile(file: File | undefined) {
  const { user } = useAuth();
  if (!file || !user) return false;
  return (
    user.role === 'admin' ||
    user.role === 'manager' ||
    file.uploadedBy === user.id ||
    file.uploadedByUser?.id === user.id
  );
}
